import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 檔案上傳 - 取得頁面資料
 */
const FileUploadViewData = [
    'POST',
    RouteUrlList.API_FileUploadViewData.path,
    {},
    200,
    {
        ssn: null,
        idCheck_Y: 0,
        idCheck_M: 0,
        idCheck_D: 0,
        idCheck_P: '',
        idCheck_T: '',
        isVerified: false,
        isValidAccount: true,
        caseTxID: '112233',
        tdccCallbackResult: null,
        requiredUploadItems: [
            {
                itemID: 101,
                itemName: '(1)身分證正面',
                isLeafNode: true,
                sortOrder: 1,
                maxMultiUpload: 0,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 102,
                itemName: '(2)身分證反面',
                isLeafNode: true,
                sortOrder: 2,
                maxMultiUpload: 0,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 103,
                itemName: '(3)第二證件',
                isLeafNode: true,
                sortOrder: 3,
                maxMultiUpload: 0,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 104,
                itemName: '(4)居留證正面',
                isLeafNode: true,
                sortOrder: 4,
                maxMultiUpload: 0,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 105,
                itemName: '(5)居留證反面',
                isLeafNode: true,
                sortOrder: 5,
                maxMultiUpload: 0,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 106,
                itemName: '(10)英文戶名證明文件',
                isLeafNode: true,
                sortOrder: 6,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 107,
                itemName: '(13)負責人第一證件',
                isLeafNode: true,
                sortOrder: 7,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 108,
                itemName: '(14)負責人第二證件',
                isLeafNode: true,
                sortOrder: 8,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 109,
                itemName: '(15)持股超過 25%自然人之第一證件',
                isLeafNode: true,
                sortOrder: 9,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 110,
                itemName: '(16)持股超過 25%自然人之第二證件',
                isLeafNode: true,
                sortOrder: 10,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 201,
                itemName: '(6)財力證明',
                isLeafNode: true,
                sortOrder: 1,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false,
                isAllowTdcc: true,
                txid: '112233'
            },
            {
                itemID: 202,
                itemName: '(6-1)庫存市值',
                isLeafNode: true,
                sortOrder: 2,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false,
                isAllowTdcc: true,
                txid: null
            },
            {
                itemID: 203,
                itemName: '(6-2)銀行餘額(含存摺封面)',
                isLeafNode: true,
                sortOrder: 3,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 204,
                itemName: '(6-3)金融機構定期存單、',
                isLeafNode: true,
                sortOrder: 4,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            },
            {
                itemID: 302,
                itemName: '(8)交易紀錄',
                isLeafNode: true,
                sortOrder: 2,
                maxMultiUpload: 5,
                documentIdFirstOrDefault: null,
                fileHash: null,
                uploadTime: null,
                isUploading: false
            }
        ],
        token: '0B3E32451263A9A68EA116CA7DD4342FF481FC34409097F39F4B5CE0D3618BCC2DB81E6900000000',
        qrCodeBase64:
            'iVBORw0KGgoAAAANSUhEUgAAAmIAAAJiAQAAAABMLZNLAAAFB0lEQVR4nO2dTY7bMAyFDcwBeqS5eo7UAwyQxiQfSTmetovZUPi0MBLbegKIx/BXyvH8wfE4QENuMARd4DeEX0vsAvYUzwEfCd9yOy/6iPHxPD5/H8fz8Svu+dPP51fcs0/P1+X13sfrw+tlH5+gIbc9GGJfnvZC+3qiGfiRM399+ap6uswADbltwJDz1VAWU694y/Qpxnnv8UKzS+jY+bIrJGjIbTeGmBadF3/rONHia6hSqaHNAA257ckQuy1jYr5XfCptCwfMTQ1oyG03hqSytJkeWuQKDTyA/um/gYbcxjEkhgzH/180EzTktgdD2nDr0YxJvOr65KmpReWWuaAht+kMsUluR4T2GqdFKY/L07R2L1a1e77WolmgIbexDKkqhOEGuGegzudywC4JKeWsbC5oyG0PhrTKRFbuXIEKvO5FuirsTSZxQUNu4xnSbYsCCgeyteyrPYjUVBYqvLL9brNAQ25DGRJqY46VUlM98HDbEopWLxuuPoGG3PZgSD7zgKK8K9MnN0RKQ8UrKmpXNQ805LYDQ7LJz5NPgoyuPtOnjMTd4/paIxfQkNsWDOkzszCtXr5qe2qlOi/fgYbcdmSIupve7Ego1XHJSoW2FS5oyG0+Qy71Og11+q1BeMvQxqjYBDTkNpwhVaeu6EMas/pZ2f/6uC4DGnLbgSFlTEJFKtIoK1PTtXRE4jlAQ27zGVJFuyxFVM/Gpe87gvAlDrl0+oGG3OYyRMZEm6SfC1oWqzP66EncayQOGnKby5BWj3BTk0F41usqKyVcU8heygYNuc1nSGlW9TSpgK2n2QQbKpeVu74qaMhtB4a0XFSEIDI1Nsr3skh8PVwGNOS2CUMKo/SpAnPZoHC7FH10INCQ2yYMqVSrZ5uqLFdHDLgWqcVJ++V6bwdoyG0+Q+ItKVB4XNr7s6RkZWXqwV1HB2jIbShDmsd1ORwgXay2dzRLeu3BN/4baMhtGEOUWcpI3A2Hsrar8lX8rZj8dm8FaMhtIkPKrPQ0VEvYpmbJz2oHVNYADbltwJDW0REa09Umd0PkqQGFexPLgIbcxjKkmjR6rJ1uV0bdlbBV9KGlQUNumzCkNknnGRkVf8sVW7r/cktdd8VAQ27jGZIFiOVysy1OWyK0YE4DDbntwpBeqlMiVp1+dT5xNQOWot3sxQYNuU1liJytyNC67mTeqR8s0FJTdrnzuEBDbqMZspwkkEnXHl8sUXe9901NHDTkNpIhyjFJs2ojRGhWrBmQ2lZdF9CQ2yYMuS/fZfKpdYU3DcxTKhMBNOQ2niH1rO2Ds0RsLtMrGD7z7dwl0JDbDgyxL1myiHNlLtNDs9QReMlPgYbctmBIHSF2+SOHWEFHylS6qkob1dYBGnIbz5Als6TtoHnSRgsy6o9OYkd1HXAMGnLbgiHR2pfTU3d6Q3h0N6mCYToWY9Us0JDbZIbEUH+G3l/3hHbzs+4xvWgWaMhtKEOkIHlaRlOWpfuvq6Ee3OR7QUNuYxniWVZtkq7mVhmYJUCJ9aVZ92c3gYbchjIkDwzozd86VcOHom7192nBv/ybA2jIbTBDen+ftC2KF3rQD3Ct+gZoyG03higHGyODkfgv6doZlHr37nGBhtzmMqRmNrdLk+zr2/9hVcnizcqAhtzGMiRG7v2pbtY6TsBnVCEvzyWTYoGG3OYz5IcGaMgNhqAL/Ibwa4ldwJ7iOeAj4Vtu5UX/AYMleL31joeGAAAAAElFTkSuQmCC',
        status: true,
        code: -1,
        exception: '',
        message: ''
    }
];

export default FileUploadViewData;
